import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import StepsAddCampaigns from "../StepsAddCampaigns";

function AllTypesNativeCampaigns() {
  let items = [
    {
      title: "نوع کمپین",
      status: true,
      link: "/campaigns/all-type",
    },
    {
      title: "نوع کمپین همسان",
      status: true,
      link: "/campaigns/all-type-native",
    },
    {
      title: "تنظیمات کمپین",
      status: false,
      link: "/campaigns/native/add-simple",
    },
  ];
  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">نوع کمپین همسان</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <StepsAddCampaigns items={items} />

              <div className="container-fluid" id="type-all-campaigns">
                <div className="row">
                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-2 pb-lg-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between ">
                      <div>
                        <div className="item-img text-center">
                          <img
                            className="w-50"
                            src="/assets/img/icon-native.svg"
                          />
                        </div>
                        <div className="item-name text-center">
                          <b>همسان عادی</b>
                        </div>
                        <div className="item-line">
                          <hr className="border border-top-1" />
                        </div>
                        <div className="item-list-data">
                          <ul className="m-0">
                            <li>افزایش ترافیک و جذب کاربر</li>
                            <li>به دست آوردن مخاطبان جدید</li>
                            <li>مناسب برای همه‌ی کسب‌وکارها</li>
                            <li>افزایش فروش کسب‌وکارها</li>
                          </ul>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center pt-3   ">
                          <Link
                            to="/campaigns/native/simple/add"
                            className="btn btn-primary"
                          >
                            انتخاب
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-2 pb-lg-0  campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between ">
                      <div>
                        <div className="item-img text-center">
                          <img
                            className="w-50"
                            src="/assets/img/icon-retargeting.svg"
                          />
                        </div>
                        <div className="item-name text-center">
                          <b>همسان ریتارگتینگ</b>
                        </div>
                        <div className="item-line">
                          <hr className="border border-top-1" />
                        </div>
                        <div className="item-list-data">
                          <ul className="m-0">
                            <li>ایجاد آگاهی از برند</li>
                            <li>افزایش فروش کسب‌وکارها</li>
                            <li>برای هدف‌گیری مجدد مخاطب‌ها</li>
                            <li>
                              مناسب برای کسب‌وکارهایی که ترافیک مناسبی دارند.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center  pt-3   ">
                          <span className="btn btn-secondary">به زودی</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between">
                      <div>
                        <div className="item-img text-center">
                          <img
                            className="w-50"
                            src="/assets/img/icon-native-contextual.png"
                          />
                        </div>
                        <div className="item-name text-center">
                          <b>همسان هدفمند (موضوعی + کلیدواژه‌ای)</b>
                        </div>
                        <div className="item-line">
                          <hr className="border border-top-1" />
                        </div>
                        <div className="item-list-data">
                          <ul className="m-0">
                            <li>جذب کاربر کاملا هدف‌مند</li>
                            <li>ایجاد آگاهی از برند</li>
                            <li>افزایش فروش کسب‌وکارها</li>
                            <li>مناسب برای همه‌ی کسب‌وکارها</li>
                          </ul>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center  pt-3  ">
                          <span className="btn btn-secondary">به زودی</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllTypesNativeCampaigns;
